import React from "react";


const HeatTooltip = ({ feature }) => {
  const  CombinedID  = feature.properties.us_node_id || "Unkown ID";
  const heat = feature.properties["heat_in_kw"];

  return (
    <div id={`tooltip-${CombinedID}`}>
      {segmentLabel(CombinedID)}
      {heatValue(heat)}
    </div>
  );
};

function heatValue(heat) {
  if (typeof heat === "number") {
    return (
      <div>
        <strong>Heat: </strong>
        {heat.toFixed(1)} kW
      </div>
    );
  }
  return <div></div>;
}
function segmentLabel(segment) {
  if (typeof segment !== "undefined") {
    return (
      <div>
        <strong>Segment: </strong>
        {segment}
        <br />
      </div>
    );
  }
  return <div></div>;
}
export default HeatTooltip;
